import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import MultiChoiceField from './MultiChoiceField';

const MultiChoice = ({ field, applications, categoriesChoiceLimits, groupByDistricts, districts, limitAnswers }) => (
  <Field
    name={field}
    component={MultiChoiceField}
    values={applications}
    categoriesChoiceLimits={categoriesChoiceLimits}
    groupByDistricts={groupByDistricts}
    districts={districts}
    limitAnswers={limitAnswers}
  />
);

MultiChoice.propTypes = {
  field: PropTypes.string.isRequired,
  applications: PropTypes.array.isRequired,
  categoriesChoiceLimits: PropTypes.array,
  groupByDistricts: PropTypes.bool.isRequired,
  districts: PropTypes.array,
  limitAnswers: PropTypes.number,
};

export default MultiChoice;


// WEBPACK FOOTER //
// ./src/components/budget/types/MultiChoice.js